import styled from '@emotion/styled';

export const ListStyled = styled.div`
    height: 300px;
    display: flex;
    
    @media (min-width: 1440px) {
        height: 330px;
    }
`;